'use client';

import { useParams } from 'next/navigation';
import { START_WORKFLOW_PATH } from '@/constants/paths';
import Button from '@mui/material/Button';
import Link from 'next/link';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import useTranslations from '@/hooks/useTranslations';
import type { CreateProductProps } from './types';

export default function CreateProduct({ title }: CreateProductProps) {
  const params = useParams();
  const { t } = useTranslations();

  return (
    <Button
      color='secondary'
      LinkComponent={Link}
      variant='contained'
      href={`/${params.locale}${START_WORKFLOW_PATH}?workflowId=${params.id}`}
      size='large'
      startIcon={<RocketLaunchRoundedIcon />}
      sx={{
        fontSize: 18,
        fontWeight: 'bold',
      }}
    >
      {`${t('menu.createNew')} ${title}`}
    </Button>
  );
}
